export default {
  // ── Common ──
  'next': '다음',
  'back': '뒤로',
  'apply': '적용하기',
  'collapse': '접기',
  'expand': '상세 보기',
  'close': '닫기',
  'search': '검색',
  'loading': '로딩 중...',
  'noResults': '검색 결과가 없어요',
  'noResultsHint': '한국어나 영어로 다시 검색해 보세요',

  // ── Intro ──
  'intro.badge': '천문학 기반 정밀 사주 분석',
  'intro.title': '시계에 적힌 시간,\n진짜 내 사주가\n아닐 수도 있어요.',
  'intro.subtitle1': '천문학 데이터를 바탕으로',
  'intro.subtitle2': '단 ',
  'intro.highlight': '1분의 오차도 없는',
  'intro.subtitle3': ' 진짜 명식을 뽑아드릴게요.',
  'intro.cta': '내 진짜 사주 찾기',
  'intro.free': '무료 · 회원가입 불필요 · 1분 소요',
  'intro.feat1': '경도 기반 진태양시',
  'intro.feat2': '역사적 서머타임 반영',
  'intro.feat3': '계절별 균시차 적용',

  // ── BirthDate ──
  'date.step': '1단계 · 생년월일',
  'date.title': '언제 태어나셨나요?',
  'date.female': '여자',
  'date.male': '남자',
  'date.solar': '양력',
  'date.lunar': '음력',
  'date.lunarLeap': '음력 윤달',
  'date.year': '연도',
  'date.month': '월',
  'date.day': '일',
  'date.yearUnit': '년',
  'date.monthUnit': '월',
  'date.dayUnit': '일',
  'date.preview.solar': '양력',
  'date.preview.lunar': '음력',
  'date.preview.lunarLeap': '음력 윤달',

  // ── BirthTime ──
  'time.step': '2단계 · 출생 시간',
  'time.title': '태어난 시간을\n정확히 아시나요?',
  'time.hint': '병원 기록부에 적힌 분 단위 시간일수록 훨씬 정확해져요. 시간을 모르면 4개 기둥 중 3개만 볼 수 있어요.',
  'time.am': '오전',
  'time.pm': '오후',
  'time.hourUnit': '시',
  'time.minuteUnit': '분',
  'time.labelAmpm': '오전/오후',
  'time.labelHour': '시',
  'time.labelMinute': '분',
  'time.unknown': '시간을 모르겠어요',
  'time.unknownModal.title': '시간을 모르시는군요',
  'time.unknownModal.body': '시간을 모르면 사주 4개 기둥 중 3개 기둥 (6글자)만 볼 수 있어요. 나중에 시간을 알게 되면 다시 입력해 보세요!',
  'time.unknownModal.confirm': '그래도 계속할게요',
  'time.midnight': '자정(00시)',

  // ── BirthLocation ──
  'location.step': '3단계 · 출생 지역',
  'location.title': '어느 동네에서\n태어나셨나요?',
  'location.hint': '정확한 우주 시간을 계산하려면 태어난 장소의 위경도 좌표가 꼭 필요해요. 병원 이름으로도 검색할 수 있어요.',
  'location.tabKorea': '국내',
  'location.tabOverseas': '해외',
  'location.placeholderKorea': '도시, 구, 병원 이름으로 검색...',
  'location.placeholderOverseas': '도시 이름 또는 영문으로 검색...',
  'location.popular.korea': '자주 찾는 지역',
  'location.popular.overseas': '자주 찾는 해외 도시',
  'location.overseas.hint': 'Tokyo, Shanghai, New York 등 영어로도 검색할 수 있어요',
  'location.fallback': '기본 데이터로 검색 중',
  'location.longitude': '경도 (Longitude)',
  'location.latitude': '위도 (Latitude)',
  'location.next': '다음',
  'location.next.disabled': '지역을 선택해주세요',

  // ── Loading ──
  'loading.analyzing': '분석 중',
  'loading.step1': '{{location}} 경도 좌표 분석 중...',
  'loading.step2': '{{year}}년 한국 표준시 기록 확인 중...',
  'loading.step3': '{{year}}년 서머타임 적용 여부 확인 중...',
  'loading.step4': '계절별 태양 오차 (균시차) 계산 중...',
  'loading.step5': '진태양시 역산 보정 중...',
  'loading.step6': '절기 교입 시간 교차 검증 중...',
  'loading.step7': '진짜 우주 시간으로 보정 완료! ✓',

  // ── Receipt ──
  'receipt.corrected': '보정 완료',
  'receipt.title': '진짜 출생 시간을\n찾았어요!',
  'receipt.header': '출생 시간 보정 내역서',
  'receipt.birthYear': '년 출생',
  'receipt.inputTime': '입력한 시계 시간',
  'receipt.longitudeCorr': '경도 보정',
  'receipt.eotCorr': '균시차 보정 (지구 타원 궤도)',
  'receipt.eotNote': '계절별 태양 오차 반영',
  'receipt.dstCorr': '서머타임 보정',
  'receipt.trueTime': '실제 태양 시간 (진태양시)',
  'receipt.totalCorr': '총 시간 보정량',
  'receipt.east': '동쪽',
  'receipt.west': '서쪽',
  'receipt.east.note': '표준시 경도 대비 동쪽에 위치',
  'receipt.west.note': '표준시 경도 대비 서쪽에 위치',
  'receipt.branchChanged.title': '⚠️ 시주가 바뀌었어요!',
  'receipt.branchChanged.body1': '원래라면 ',
  'receipt.branchChanged.body2': '로 나올 사주가, 정밀 보정을 거쳐 ',
  'receipt.branchChanged.body3': '로 바뀌었어요!',
  'receipt.cta': '내 사주 팔자 확인하기',
  'receipt.dst.note': '서머타임 기간 출생 (−60분 보정)',

  // ── SajuResult ──
  'result.badge': '정밀 보정 완료',
  'result.title': '이것이 바로\n8개의 글자예요.',
  'result.unknownTime': '시간을 모르셔서 시주(時柱)를 제외한 3주 6자를 보여드려요.',
  'result.lunarConv.title': '음력 → 양력 자동 변환',
  'result.lunarConv.body1': '음력 ',
  'result.lunarConv.body2': ' → 양력 ',
  'result.lunarConv.body3': '으로 변환하여 계산했어요.',
  'result.lunarLeap': '음력 윤달 ',
  'result.calc.title': '계산 근거',
  'result.calc.longitude': '출생지 경도',
  'result.calc.eot': '균시차',
  'result.calc.trueTime': '적용된 진태양시',
  'result.dayInterp.label': '일주 해석',
  'result.dayInterp.personality': '성격 특성',
  'result.dayInterp.strengths': '강점',
  'result.dayInterp.weaknesses': '주의',
  'result.dayInterp.advice': '당신에게 필요한 조언',
  'result.tab.fortune': '운세',
  'result.tab.analysis': '사주분석',
  'result.tab.calendar': '달력',
  'result.expert': '전문가 설정',
  'result.expert.title': '전문가 설정',
  'result.expert.yajasi.title': '자시 (子時) 기준',
  'result.expert.yajasi.desc': '밤 11시~자정에 태어나신 분이라면 이 설정이 사주에 영향을 줄 수 있어요. 학자마다 의견이 다른 부분이에요.',
  'result.expert.yajasi.ya': '야자시 (오늘 子時)',
  'result.expert.yajasi.ya.desc': '밤 11시 = 오늘로 봄',
  'result.expert.yajasi.jo': '조자시 (내일 子時)',
  'result.expert.yajasi.jo.desc': '밤 11시 = 내일로 봄',
  'result.yearlyReport.title': '2026년 신년운세 리포트',
  'result.yearlyReport.subtitle': '기밀문서 형식의 정밀 운명 분석 →',
  'result.yearlyReport.classified': 'CLASSIFIED',
  'result.restart': '다른 사주 계산하기',
  'result.timeUnknownHour': '시간 미입력',
  'result.stemLabel': '천간',
  'result.branchLabel': '지지',

  // ── Ohaeng ──
  'ohaeng.title': '오행(五行) 에너지 분석',
  'ohaeng.subtitle': '월지 계절 가중치 포함 정밀 계산',
  'ohaeng.dominant': '가장 강한 기운',
  'ohaeng.dominant.full': '기운이 가득해요!',
  'ohaeng.lacking': '보완이 필요한 기운',
  'ohaeng.flow': '오행 흐름',
  'ohaeng.flow.label': '오행 흐름:',
  'ohaeng.flow.desc': '목 → 화 → 토 → 금 → 수 → 목 (상생) / 목극토 · 화극금 · 토극수 · 금극목 · 수극화 (상극)',
  'ohaeng.wood': '나무(木)',
  'ohaeng.fire': '불(火)',
  'ohaeng.earth': '흙(土)',
  'ohaeng.metal': '쇠(金)',
  'ohaeng.water': '물(水)',
  'ohaeng.personality.wood': '성장 본능이 강하고 새로운 것에 도전하길 좋아해요. 리더십과 창의력이 넘쳐요.',
  'ohaeng.personality.fire': '뜨거운 열정과 표현력! 카리스마 넘치고 주변을 밝게 만들어요.',
  'ohaeng.personality.earth': '든든하고 믿음직한 기운. 꾸준함과 신뢰가 가장 큰 강점이에요.',
  'ohaeng.personality.metal': '날카로운 판단력과 결단력. 정밀하고 논리적인 사고를 해요.',
  'ohaeng.personality.water': '깊은 지혜와 유연함. 상황에 따라 스며드는 적응력이 뛰어나요.',
  'ohaeng.lacking.wood': '조금 더 끈기와 인내를 기르면 좋겠어요.',
  'ohaeng.lacking.fire': '열정이 부족할 수 있어요. 목표를 향한 불꽃을 피워보세요.',
  'ohaeng.lacking.earth': '안정감이 필요한 시기예요. 루틴을 만들어보세요.',
  'ohaeng.lacking.metal': '결단력이 필요해요. 더 명확하게 선택하고 실행해보세요.',
  'ohaeng.lacking.water': '유연성과 지혜를 키우면 인생이 더 풍요로워져요.',

  // ── Daeun ──
  'daeun.title': '대운(大運) 흐름',
  'daeun.desc': '10년마다 찾아오는 큰 운의 흐름이에요. 대운이 바뀌면 인생의 방향이 달라져요.',
  'daeun.current': '현재 대운',
  'daeun.forward': '순행(順行)',
  'daeun.backward': '역행(逆行)',
  'daeun.startAge': '세 후 시작',
  'daeun.startAge.months': '개월',
  'daeun.startAge.immediate': '출생 직후 시작',
  'daeun.guide.title': '대운 보는 법',
  'daeun.guide.desc': '각 칸은 10년을 나타내요. 천간(위 글자)은 외부 환경과 사회적 흐름을, 지지(아래 글자)는 내면의 변화를 나타냅니다.',
  'daeun.age.range': '~',
  'daeun.age.unit': '세',
  'daeun.year.unit': '년~',

  // ── Sewoon ──
  'sewoon.title.suffix': '년 세운',
  'sewoon.subtitle': '올해의 운세 흐름',
  'sewoon.score': '올해 운세 점수',
  'sewoon.career': '커리어',
  'sewoon.love': '연애/인연',
  'sewoon.money': '금전',
  'sewoon.health': '건강',
  'sewoon.monthly.title': '월별 운세',
  'sewoon.monthly.detail': '상세보기',
  'sewoon.monthly.collapse': '접기',
  'sewoon.lucky.title': '년 행운 정보',
  'sewoon.lucky.color': '행운의 색',
  'sewoon.lucky.number': '행운의 숫자',
  'sewoon.lucky.direction': '행운의 방향',
  'sewoon.advice.title': '올해의 조언',
  'sewoon.level.excellent': '최상',
  'sewoon.level.good': '상',
  'sewoon.level.normal': '중',
  'sewoon.level.challenging': '하',
  'sewoon.level.difficult': '최하',

  // ── Monthly Fortune ──
  'monthly.title': '월별 운세',
  'monthly.title.year': '{{year}}년 월별 운세',
  'monthly.subtitle': '나의 사주와 달마다 달라지는 흐름',
  'monthly.good': '좋은 달',
  'monthly.normal': '보통 달',
  'monthly.caution': '주의 달',
  'monthly.tab.all': '전체',
  'monthly.tab.good': '좋은 달',
  'monthly.tab.bad': '주의 달',
  'monthly.empty': '해당하는 달이 없어요',
  'monthly.score.great': '대길',
  'monthly.score.good': '길',
  'monthly.score.normal': '평',
  'monthly.score.caution': '주의',
  'monthly.score.bad': '흉',
  'monthly.month.suffix': '월',

  // ── Sipseong ──
  'sipseong.title': '십성(十星) 분석',
  'sipseong.subtitle': '사주 8자가 나에게 하는 역할',
  'sipseong.dominant': '가장 강한 십성',
  'sipseong.hidden.title': '무의식 속 숨은 기운 (지장간)',
  'sipseong.hidden.label': '깊이 숨어있는 기운: ',
  'sipseong.tab.career': '커리어',
  'sipseong.tab.love': '연애',
  'sipseong.tab.wealth': '금전',
  'sipseong.advice.title': '나에게 하는 말',
  'sipseong.category.top': '강한 카테고리 기운',
  'sipseong.detail.title': '각 기둥 상세 보기',
  'sipseong.detail.stem': '천간',
  'sipseong.detail.branch': '지지',
  'sipseong.detail.jijang': '지장간',
  'sipseong.detail.daegan': '나(日干)',

  // ── Singangyak ──
  'singangyak.title': '신강/신약(身强身弱) 분석',
  'singangyak.subtitle': '내 기운의 강도와 균형 지수',
  'singangyak.deonnyeong': '득령',
  'singangyak.present': '✓ 있음',
  'singangyak.absent': '✗ 없음',
  'singangyak.gauge.extremeWeak': '극신약',
  'singangyak.gauge.balanced': '중화',
  'singangyak.gauge.extremeStrong': '극신강',
  'singangyak.gauge.weakSide': '신약 쪽',
  'singangyak.gauge.strongSide': '신강 쪽',
  'singangyak.detail.title': '상세 점수 보기',
  'singangyak.detail.deotnyeong': '득령(得令)',
  'singangyak.detail.deotnyeong.desc': '태어난 달 기운',
  'singangyak.detail.deotji': '득지(得地)',
  'singangyak.detail.deotji.desc': '일지 기운',
  'singangyak.detail.deotse': '득세(得勢)',
  'singangyak.detail.deotse.desc': '주변 글자 지원',
  'singangyak.yongshin.title': '행운의 열쇠',
  'singangyak.yongshin.label': '용신(用神): ',
  'singangyak.note': '※ 신강/신약 판단은 사주 학파에 따라 다를 수 있어요. 이 계산은 득령·득지·득세 기준의 기본 방식을 따릅니다.',

  // ── ShareCard ──
  'share.button': '사주 결과 공유하기',
  'share.pillarTitle': '나의 사주 팔자',
  'share.dayPillarLabel': '일주(日柱) — 나의 본질',
  'share.hourPillar': '시주',
  'share.kakao': '카카오톡',
  'share.copyLink': '링크 복사',
  'share.copied': '복사됨!',
  'share.copyText': '텍스트 복사',
  'share.more': '더보기',
  'share.footer': '바른사주 — 정밀 진태양시 사주 계산',
  'share.appTitle': '바른사주',
  'share.kakaoTitle': '바른사주 — 나의 사주 결과',
  'share.nativeTitle': '바른사주 결과',

  // ── SajuHistory ──
  'history.title': '최근 사주 기록',
  'history.empty': '아직 계산한 사주가 없어요',
  'history.empty.hint': '내 사주를 계산하면 자동으로 저장돼요',
  'history.timeUnknown': '시간 미입력',
};
